import React, { Component, ReactNode } from 'react';

import { Notification } from '@vimeo/iris/components';

import { ErrorNotification } from '../types';

interface RenderProps {
  handleError: (e: ErrorNotification) => void;
}

interface Props {
  children: (p: RenderProps) => ReactNode;
}

interface State extends Partial<ErrorNotification> {
  handleError: (e: ErrorNotification) => void;
}

export default class ErrorNotifier extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      handleError: this.handleError,
    };
  }

  public render() {
    const error = this.requestError();

    return (
      <div>
        {this.props.children({
          handleError: this.state.handleError,
        })}
        <Notification status="negative" showing={!!error} content={error || ''} />
      </div>
    );
  }

  private handleError = ({ error, message }: ErrorNotification) => {
    console.error(error);

    this.setState((state) => {
      return {
        ...state,
        error,
        message,
      };
    });
  };

  private requestError = () => {
    const { error, message } = this.state;

    if (error && message) {
      return `${message}: ${error}`;
    }
  };
}
